import { render, staticRenderFns } from "./UnitFormatter.vue?vue&type=template&id=cc89f8ce&functional=true"
import script from "./UnitFormatter.vue?vue&type=script&lang=js"
export * from "./UnitFormatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports